<template>
  <!-- 电表充值扣缴 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permissionList.importRechargeBtn"
          type="success"
          plain
          size="small"
          icon="el-icon-upload2"
          @click="openDialog('importRecharge')"
        >
          导入充值
        </el-button>
        <el-button
          v-if="permissionList.importWithholdBtn"
          type="success"
          plain
          size="small"
          icon="el-icon-upload2"
          @click="openDialog('importWithhold')"
        >
          导入扣缴账单
        </el-button>
        <el-button
          v-if="permissionList.exportBtn"
          type="success"
          plain
          size="small"
          icon="el-icon-download"
          @click="exportData"
        >
          导出
        </el-button>
        <el-button v-if="permissionList.logBtn" size="small" @click="openDialog('log')">
          失败日志
        </el-button>
        <div class="sum-tips">
          <strong>充值扣缴明细记录</strong>
          {{
            `共计${sumInfo.totalCount || ' '}笔，扣缴${sumInfo.reduceCount ||
              ' '}笔，${sumInfo.reduceAmountCount || ' '}元，充值${sumInfo.chargeCount ||
              ' '}笔，${sumInfo.chargeAmountCount || ' '}元`
          }}
        </div>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.detailBtn"
          type="text"
          size="small"
          @click="openDialog('detail', row)"
        >
          详情
        </el-button>
      </template>
      <template slot="propertyIdSearch">
        <LazyTree
          placeholder="关联房产"
          @load="getPropertyTreeData"
          @setDefaultFinished="loadData"
          :needDefaultItem="true"
          :needDelIcon="false"
          :selectedId.sync="currPropertyId"
          :treeProps="{
            label: 'objectFullName',
            value: 'id',
          }"
        ></LazyTree>
      </template>
      <template slot="codeSearch">
        <el-select
          style="width: 100%"
          v-model="searchForm.meterId"
          placeholder="电表表号"
          clearable
        >
          <el-option
            v-for="(item, index) in meters"
            :key="index"
            :label="item.code"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot="operateTimeSearch">
        <el-date-picker
          v-model="dateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :default-time="['00:00:00', '23:59:59']"
          style="width: 100%"
        >
        </el-date-picker>
      </template>
      <template slot="propertyId" slot-scope="{ row }">
        <span>{{ row.propertyName }}</span>
      </template>
      <template slot="chargeType" slot-scope="{ row }">
        <span>{{ row.chargeTypeStr }}</span>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      v-if="isDialogShow"
      :width="dialogType == 'importRecharge' || dialogType == 'importWithhold' ? '400px' : '60%'"
      :title="dialogType == 'importRecharge' || dialogType == 'importWithhold' ? '' : dialogTitle"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <LogList v-if="dialogType == 'log'" :rowData="rowData"></LogList>
      <Detail
        v-else-if="dialogType == 'rechargeDetail' || dialogType == 'withholdDetail'"
        :dialogType="dialogType"
        :rowData="rowData"
      ></Detail>
      <ImportFile
        v-else-if="dialogType == 'importRecharge'"
        :title="dialogTitle"
        :withApiTips="true"
        exportApi="/api/v4ward/prePay/electricity/charge/exportChargeTemplate"
        importApi="/api/v4ward/prePay/electricity/charge/importChargeRecord"
        @uploadCallBack="importCallBack"
      ></ImportFile>
      <ImportFile
        v-else-if="dialogType == 'importWithhold'"
        :title="dialogTitle"
        :withApiTips="true"
        exportApi="/api/v4ward/prePay/electricity/charge/exportReduceTemplate"
        importApi="/api/v4ward/prePay/electricity/charge/importReduceRecord"
        @uploadCallBack="importCallBack"
      ></ImportFile>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import qs from 'qs';
import LazyTree from '@/views/components/lazy-tree';
import ImportFile from '@/views/nursingHome/initData/importFile';
import LogList from './log-list';
import Detail from './detail';
import { getToken } from '@/util/auth';
import { getTreeChildrenPowerNode } from '@/api/v4ward/property/baseproperty';
import {
  getPageListApi,
  getSumInfoApi,
  getMetersApi,
} from '@/api/electric-meter/electric-meter-bill';

export default {
  components: {
    LazyTree,
    ImportFile,
    LogList,
    Detail,
  },
  data() {
    return {
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      rowData: [], // 选中行对应的数据
      // 搜索条件
      searchForm: {
        propertyId: '',
        meterId: '',
      },
      currPropertyId: '', // 房产id
      meters: [], // 电表列表
      dateRange: [], // 搜索条件-起止日期
      sumInfo: {}, // 合计数据
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 12,
        searchLabelWidth: 80,
        menuWidth: 80,
        column: [
          {
            label: '电表表号',
            prop: 'code',
            search: true,
            searchslot: true,
          },
          {
            label: '关联房产',
            prop: 'propertyId',
            slot: true,
            search: true,
            searchslot: true,
            searchOrder: 2,
          },
          {
            label: '类型',
            prop: 'chargeType',
            slot: true,
            search: true,
            type: 'select',
            props: { label: 'dictValue', value: 'dictKey' },
            dicData: [
              {
                dictValue: '充值',
                dictKey: 1,
              },
              {
                dictValue: '扣缴',
                dictKey: 2,
              },
            ],
          },
          {
            label: '发生金额（元）',
            prop: 'changeAmountStr',
            align: 'right',
          },
          {
            label: '发生前余额（元）',
            prop: 'beforeBalance',
            align: 'right',
          },
          {
            label: '发生后余额（元）',
            prop: 'afterBalance',
            align: 'right',
          },
          {
            label: '发生时间',
            prop: 'operateTime',
            search: true,
            searchslot: true,
            searchSpan: 12,
          },
          {
            label: '操作人',
            prop: 'operateMan',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        importRechargeBtn: this.vaildData(this.permission.electricMeterBill_importRecharge, false),
        importWithholdBtn: this.vaildData(this.permission.electricMeterBill_importWithhold, false),
        exportBtn: this.vaildData(this.permission.electricMeterBill_export, false),
        logBtn: this.vaildData(this.permission.electricMeterBill_log, false),
        detailBtn: this.vaildData(this.permission.electricMeterBill_detail, false),
      };
    },
  },
  watch: {
    currPropertyId() {
      this.searchForm.propertyId = this.currPropertyId;
      this.searchForm.meterId = '';
      this.meters = [];
      getMetersApi({
        propertyId: this.currPropertyId,
      }).then(({ data }) => {
        this.meters = data;
      });
    },
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 430; // 表格区域初始化高度
      const searchH = 112; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      // watch有异步延时，这里如果检测到值没有及时同步，则手动同步一下
      if (this.currPropertyId && !this.searchForm.propertyId) {
        this.searchForm.propertyId = this.currPropertyId;
      }
      if (!this.searchForm.propertyId) return;
      page = page || this.tablePage;
      this.loading = true;
      // 每次请求第一页数据时都刷新汇总数据
      if (page.currentPage == 1) {
        getSumInfoApi(this.searchForm).then(({ data }) => {
          this.sumInfo = data;
        });
      }
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.dateRange = [];
      this.searchForm = {
        propertyId: this.currPropertyId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.dealDateRange();
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 转化日期范围 */
    dealDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.operateTimeSearchStart = this.dayjs(this.dateRange[0]).format(
          'YYYY-MM-DD HH:mm:ss'
        );
        this.searchForm.operateTimeSearchEnd = this.dayjs(this.dateRange[1]).format(
          'YYYY-MM-DD HH:mm:ss'
        );
      } else {
        this.searchForm.operateTimeSearchStart = '';
        this.searchForm.operateTimeSearchEnd = '';
        this.dateRange = [];
      }
    },
    /* 表格数据更新成功 */
    updateTableDataSuccess() {
      this.loadData();
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        importRecharge: '导入充值',
        importWithhold: '导入扣缴账单',
        log: '失败日志',
        rechargeDetail: '充值详情',
        withholdDetail: '扣缴详情',
      };
      if (type == 'detail') {
        if (rowData.chargeType == '1') {
          type = 'rechargeDetail';
        } else {
          type = 'withholdDetail';
        }
      }
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      if (type == 'importRecharge' || type == 'importWithhold') {
        this.needCloseConfirm = true;
      } else {
        this.needCloseConfirm = false;
      }
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
    /* 直接关闭弹框 */
    closeDialog() {
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 导入成功的回调 */
    importCallBack(ret) {
      if (ret) {
        this.closeDialog();
        this.tablePage.currentPage = 1;
        this.tablePage.total = 0;
        this.tableData = [];
        this.loadData();
      }
    },
    /* 导出 */
    exportData() {
      let params = qs.stringify(this.searchForm);
      window.open(
        `/api/v4ward/prePay/electricity/charge/exportBalanceChangeLog?${
          this.website.tokenHeader
        }=${getToken()}&${params}`
      );
    },
    /* 加载房产树的数据 */
    getPropertyTreeData(node, resolve) {
      getTreeChildrenPowerNode({
        id: node.level == 0 ? 0 : node.data.id,
        power: 1,
      }).then(({ data }) => {
        resolve(data);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
